var KEY = 'DataGrid:ResizeStorage';
var EMPTY_STORAGE_DATA = {
    columnSizes: {},
    columnVisibility: {},
    columnOrders: {}
};
var LocalDataGridPersistentStorage = /** @class */ (function () {
    function LocalDataGridPersistentStorage(key) {
        this.key = KEY + ":" + key + "\"";
    }
    LocalDataGridPersistentStorage.prototype.save = function (payload) {
        localStorage.setItem(this.key, JSON.stringify(payload));
    };
    LocalDataGridPersistentStorage.prototype.read = function () {
        try {
            return JSON.parse(localStorage.getItem(this.key) || '""') || EMPTY_STORAGE_DATA;
        }
        catch (_a) {
            return EMPTY_STORAGE_DATA;
        }
    };
    return LocalDataGridPersistentStorage;
}());
export { LocalDataGridPersistentStorage };
//# sourceMappingURL=LocalDataGridPersistentStorage.js.map